import { MonitoramentoListSearchComponent } from './MonitoramentoListSearchComponent'

export const MonitoramentoListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <MonitoramentoListSearchComponent />
  </div>
)
